import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, InputBase, Checkbox } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, trim } from 'lodash';
import posthog from 'posthog-js';

import Color from '@tool/color';
import moLogin, {
  toggleLogin, changeLoginType, toggleValue, getCaptcha,
  changeAccount, changePassword, changePhone, changeCaptcha,
  onPhoneLogin, onAccountLogin, loginInit,
  authorizeOAuthSession, getOAuthAuthorizationRequest,
} from '@store/login';
import moSkin from '@store/skin';
import {
  DButton, SmallButton, LoginButton, EButton,
  DInput, DCheckbox,
} from './styled';
import Service from '@service/login';
import AppLoading from '@con/app-loading';
import { isOAuthAuthorizationNavigation } from '@lib/oauth-authorization';
import { buildAuthPagePath } from '@lib/registration-attribution';

interface IProps {
  isModal?: boolean,
}
interface IState { }

const FButton = styled(EButton)(() => ({
  '&.text-15': {
    cursor: 'default',
    backgroundColor: Color.c999,
  },
}));

const Login = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const location = useLocation();
  const { isModal } = props;
  const {
    loginType, rememberPhone, rememberPwd,
    account, password, phone, captcha,
    accountEmpty, passwordEmpty, phoneErrorText,
    phoneEmpty, captchaEmpty, qrText, qrClass,
  } = moLogin;
  const { mainColor, partner } = moSkin;

  useEffect(() => {
    if (!isOAuthAuthorizationNavigation(window.location.search)) {
      posthog.capture('登录页浏览', {});
    }
    loginInit();
    authorizeOAuthSession();

    return () => { };
  }, []);

  const onLogin = () => {
    const isOAuthNavigation = isOAuthAuthorizationNavigation(location.search);
    if (!isOAuthNavigation) {
      posthog.capture('点击登录人数', {});
      const urlBack = location.pathname;
      localStorage.setItem('urlBack', `${urlBack}${location.search}`);
    }
    if (loginType === 'account') onAccountLogin();
    else onPhoneLogin();
  };

  const onRegister = () => {
    posthog.capture('登录-注册新用户按钮', {});
    navi(buildAuthPagePath('/register', location.search));
  };

  const onForget = () => { navi(buildAuthPagePath('/forget', location.search)); };

  const onContact = () => {
    posthog.capture('登录-联系客服按钮', {});
    const $btn = document.getElementById('nb_invite_ok');
    if ($btn) $btn.click();
  };

  return (
    <section className="login-155">
      <strong>欢迎登录</strong>
      <p className="line-011">
        <DButton onClick={() => changeLoginType('phone')}
          className={loginType === 'phone' ? 'active' : ''}>手机登录
        </DButton>
        <DButton onClick={() => changeLoginType('account')}
          className={loginType === 'account' ? 'active' : ''}>账号登录
        </DButton>
      </p>
      {loginType === 'account' ? (
        <section className="line-012">
          <section className="line-115 line-116">
            <DInput value={account} placeholder="请输入邮箱/手机号码"
              onChange={changeAccount} />
            <span className={[
              'err-11', accountEmpty ? 'err-visible' : 'err-hidden',
            ].join(' ')}>邮箱/手机号码不能为空
            </span>
          </section>
          <section className="line-115 line-117">
            <DInput value={password} type="password" placeholder="请输入密码"
              onChange={changePassword} />
            <span className={[
              'err-11', passwordEmpty ? 'err-visible' : 'err-hidden',
            ].join(' ')}>密码不能为空
            </span>
          </section>
          <section className="line-0015">
            <DCheckbox color="primary" size="small" checked={rememberPwd}
              onClick={() => toggleValue('rememberPwd', !rememberPwd)} />
            <span className="text-11">记住密码</span>
          </section>
        </section>
      ) : (
        <section className="line-012">
          <section className="line-115 line-116">
            <DInput value={phone} placeholder="请输入手机号码"
              onChange={changePhone} />
            <span className={[
              'err-11', phoneEmpty ? 'err-visible' : 'err-hidden',
            ].join(' ')}>{phoneErrorText}
            </span>
          </section>
          <section className="line-0011 line-117">
            <DInput value={captcha} placeholder="请输入验证码"
              onChange={changeCaptcha} />
            <FButton onClick={getCaptcha}
              className={[qrClass ? 'text-15' : ''].join(' ')}
              style={{ backgroundColor: qrText === '获取验证码' ? mainColor : Color.c999 }}>{qrText}
            </FButton>
            <span className={[
              'err-11', captchaEmpty ? 'err-visible' : 'err-hidden',
            ].join(' ')}>验证码不能为空
            </span>
          </section>
          <p className="line-0015">
            <DCheckbox color="primary" size="small" checked={rememberPhone}
              onClick={() => toggleValue('rememberPhone', !rememberPhone)} />
            <span className="text-11">记住手机号</span>
          </p>
        </section>
      )}
      <LoginButton onClick={onLogin}
        style={{ backgroundColor: mainColor }}>登录
      </LoginButton>
      {!isModal ? (
        <p className="line-013">
          <SmallButton onClick={onRegister}>注册新账号</SmallButton>
          <i style={{ margin: '0 20px' }}>|</i>
          <SmallButton onClick={onForget}>忘记密码</SmallButton>
          {partner === 'smartsalary' ? (
            <>
              <i style={{ margin: '0 20px' }}>|</i>
              <SmallButton onClick={onContact}>联系客服</SmallButton>
            </>
          ) : null}
        </p>
      ) : (
        <p className="line-013">
          <SmallButton onClick={onRegister}>注册新账号</SmallButton>
          <i style={{ margin: '0 20px' }}>|</i>
          <SmallButton onClick={onForget}>忘记密码</SmallButton>
        </p>
      )}
      <AppLoading />
    </section>
  );
};

export default observer(Login);
